import { supabase } from '../../config/supabaseClient';
import { ENV } from '../../config/env';

export interface ActivityLogItem {
  id: string;
  organization_id: string;
  entity_type: 'project' | 'task' | 'comment' | 'milestone';
  entity_id: string;
  user_id: string;
  action: string;
  changes: Record<string, any>;
  created_at: string;
}

export interface ListActivityParams {
  organization_id: string;
  entity_type?: string;
  entity_id?: string;
  limit?: number;
  offset?: number;
}

async function getToken(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  return session.access_token;
}

const API_BASE_URL = `${ENV.API_URL}/api/project-management/activity`;

export const activityService = {
  async list(params: ListActivityParams): Promise<{ data: ActivityLogItem[]; error: any }> {
    try {
      const token = await getToken();
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, String(value));
        }
      });

      const response = await fetch(`${API_BASE_URL}?${queryParams.toString()}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (!response.ok) {
        return { data: [], error: result?.error || 'Failed to fetch activity' };
      }

      return { data: (result.data || []) as ActivityLogItem[], error: null };
    } catch (err: any) {
      return { data: [], error: err.message || 'Network error' };
    }
  },
};

export default activityService;
